import { render, staticRenderFns } from "./widget_ver_fat.vue?vue&type=template&id=4590edfd&scoped=true&"
import script from "./widget_ver_fat.vue?vue&type=script&lang=js&"
export * from "./widget_ver_fat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4590edfd",
  null
  
)

export default component.exports